import Grid from "@mui/material/Grid2";
import theme from "src/themes";

const HighlightValue = ({
  value,
  color,
  backgroundColor,
  highlighted = false
}: {
  value: string;
  color?: string;
  backgroundColor?: string;
  highlighted?: boolean;
}) => {
  return (
    <Grid container justifyContent={"flex-end"}>
      <Grid
        style={{
          height: "30px",
          minWidth: "30px",
          color: highlighted ? theme.palette.secondary.dark : color || "",
          backgroundColor: highlighted
            ? theme.palette.error.light
            : backgroundColor || "",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "2px",
          padding: "8px"
        }}
      >
        <span style={{ fontWeight: 500 }}>{value}</span>
      </Grid>
    </Grid>
  );
};

export default HighlightValue;
